import React, { useEffect, useState } from "react";
import styles from "./UserReviewPage.module.css";
import { setHeader } from "../../reduxSlices/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import VFLogo from "../../assets/images/vf-logo.png";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import ButtonCta1 from "../../components/button/ButtonCta1";
import { Service } from "../../services/service";
import {
  CLIENT_ADMIN_ROLE_ID,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
} from "../../constants/constant";
import { toast } from "react-toastify";
import { getUserLogin } from "../../reduxSlices/userSlice";
import { Navigate, useNavigate } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ProfilePic from "../../assets/images/ProfilePic1.svg";
import ImageUploader from "../../components/imageuploader/ImageUploader";

const service = new Service();

const UserReviewPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userRole = useSelector((state) => state?.user?.userRoleId);
  const userRoles = useSelector((state) => state?.user?.userRole);
  const currentUser = useSelector((state) => state?.user?.currentUser?.data);

  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [value, setValue] = useState("standard");
  const [selectedValues, setSelectedValues] = useState([]);
  const [user, setUser] = useState({
    userId: "",
    emailId: "",
    familyName: "",
    givenName: "",
    organization: {},
    isActive: true,
    isAdmin: true,
    roles: [],
  });

  useEffect(() => {
    setValue(userRole?.includes(USER_ROLE_ID) ? "standard" : "admin");
    setSelectedValues(userRoles);
  }, [userRole, userRoles]);

  useEffect(() => {
    setUser({
      userId: currentUser?.userId,
      emailId: currentUser?.emailId,
      familyName: currentUser?.familyName,
      givenName: currentUser?.givenName,
      organization: currentUser?.organization,
      isActive: currentUser?.isActive,
      isAdmin: currentUser?.isAdmin,
      roles: currentUser?.roles,
    });
    setImageUrl(currentUser?.profileImage);
  }, [currentUser]);

  console.log("currentUser", currentUser);

  useEffect(() => {
    dispatch(
      setHeader({
        page: "user-review",
        title: "User Review",
        subTitle: "",
      })
    );
  }, []);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleRadioChange = (value) => {
    const currentIndex = selectedValues.indexOf(value);
    const newSelectedValues = [...selectedValues];

    if (currentIndex === -1) {
      newSelectedValues.push(value);
    } else {
      newSelectedValues.splice(currentIndex, 1);
    }

    setSelectedValues(newSelectedValues);
  };

  const handleOrganizationChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateUser();
  };

  const updateUser = async () => {
    let url = `/api/User/UpdateUser`;
    const user_token = localStorage.getItem("bb_access_token");
    const userData = prepareUserData();
    const formData = JSON.stringify(userData);
    try {
      let data = await service.newPutApi(url, formData, user_token);
      let resp = data.data;
      let emailId = resp.emailId;
      console.log("resp", resp, emailId);
      if (emailId) {
        const obj = {
          email: emailId,
        };
        dispatch(getUserLogin(obj));
      }
      if (resp?.data && resp?.success) {
        toast.success("Your account details has been updated!", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        setUser({ emailId: "", familyName: "", givenName: "" });
        navigate("/dashboard");
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message, toastConfig);
    }
  };

  const prepareUserData = () => {
    return {
      userId: user?.userId,
      emailId: user?.emailId,
      familyName: user?.familyName,
      givenName: user?.givenName,
      organization: user?.organization,
      isActive: user?.isActive,
      isAdmin: user?.isAdmin,
      roles: user?.roles,
    };
  };

  console.log("prepareUserData", prepareUserData());

  return (
    <div>
      <div className={styles.topheaderLeft} style={{ marginBottom: "40px" }}>
        {/* <b className={styles.headerTitle}>Review User Details</b> */}
        <div className={styles.headerTitle}>Review personal details</div>
        <div className={styles.goremIpsumDolor1}>
          Please review your personal details and contact your administrator in
          case of any discrepancy
        </div>
      </div>
      <ImageUploader
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        imageUrl={imageUrl}
        setImageUrl={setImageUrl}
        bgColor="#fff"
      />
      <Box
        component="form"
        sx={{
          "& > :not(style)": { marginBottom: "40px" },
        }}
        noValidate
        autoComplete="off"
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              First Name<sup style={requiredAr}>*</sup>
            </label>
            <TextField
              disabled
              id="outlined-basic"
              variant="outlined"
              type="text"
              name="givenName"
              sx={{ width: "240px" }}
              value={user.givenName}
              onChange={handleOrganizationChange}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "40px",
            }}
          >
            <label style={labelStyle}>Last Name (Optional)</label>
            <TextField
              id="outlined-basic"
              variant="outlined"
              type="text"
              name="familyName"
              sx={{ width: "240px", backgroundColor: "#fff", color: "#8a8a8a" }}
              value={user.familyName}
              onChange={handleOrganizationChange}
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <label style={labelStyle}>
            Email<sup style={requiredAr}>*</sup>
          </label>
          <TextField
            disabled
            id="outlined-basic"
            variant="outlined"
            type="text"
            name="emailId"
            sx={{ width: "520px" }}
            value={user.emailId}
            onChange={handleOrganizationChange}
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <label style={labelStyle}>
            Access<sup style={requiredAr}>*</sup>
          </label>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              // value={value}
              // onChange={handleChange}
            >
              {userRole?.includes(VF_ADMIN_ROLE_ID) && (
                <>
                  <FormControlLabel
                    disabled
                    // value="VF Admin"
                    control={
                      <Radio
                        checked={selectedValues.includes("VFAdmin")}
                        onChange={() => handleRadioChange("VFAdmin")}
                      />
                    }
                    label="Visualise Admin"
                  />
                  <Typography sx={typoStyle}>
                    Visualise Admin can manage users, organisations, reports, packages,
                    data translation settings, etc.
                  </Typography>
                </>
              )}
              {userRole?.includes(CLIENT_ADMIN_ROLE_ID) && (
                <>
                  <FormControlLabel
                    disabled
                    // value="admin"
                    control={
                      <Radio
                        checked={selectedValues.includes("Admin")}
                        onChange={() => handleRadioChange("Admin")}
                      />
                    }
                    label="Admin"
                  />
                  <Typography sx={typoStyle}>
                    Admin can manage users, data translation settings and review
                    reports based on the package.
                  </Typography>
                </>
              )}
              {userRole?.includes(USER_ROLE_ID) && (
                <>
                  <FormControlLabel
                    disabled
                    // value="standard"
                    control={
                      <Radio
                        checked={selectedValues.includes("Standard")}
                        onChange={() => handleRadioChange("Standard")}
                      />
                    }
                    label="Standard"
                  />
                  <Typography sx={typoStyle}>
                    Standard user can review reports based on the package and
                    data translation settings.
                  </Typography>
                </>
              )}
            </RadioGroup>
          </FormControl>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box>
            <ButtonCta1
              text="Continue"
              onClick={(e) => handleSubmit(e)}
              variant="contained"
              disabled={false}
              width="122px"
              height="48px"
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default UserReviewPage;

const labelStyle = {
  fontSize: "16px",
  letterSpacing: "-0.02em",
  fontWeight: 500,
  fontFamily: "Montserrat",
  color: "#000",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};

const typoStyle = {
  fontSize: "12px",
  letterSpacing: "-0.02em",
  lineHeight: "16px",
  fontWeight: 500,
  // fontFamily: "Montserrat",
  color: "#8a8a8a",
  textAlign: "left",
  display: "inline-block",
  width: "410px",
  marginLeft: "30px",
};
